import type { OAuthAccount } from '@frontend/api-types';

export const getDedicatedCalendarAccounts = (accounts: MaybeUndefined<OAuthAccount[]> = []) =>
  accounts.filter((a) => !a.isDuckbillShared);
